var _defs, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _use10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoader = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  fill: "#fcfcfc",
  stroke: "#fcfcfc",
  className: "loader_svg__single-loader",
  overflow: "visible",
  viewBox: "0 0 100 100"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "loader_svg__a",
  width: 7,
  height: 20,
  x: 46.5,
  y: 40,
  rx: 2,
  ry: 2,
  transform: "translate(0 -30)"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a",
  transform: "rotate(30 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.08s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a",
  transform: "rotate(60 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.16s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a",
  transform: "rotate(90 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.24s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a",
  transform: "rotate(120 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.32s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a",
  transform: "rotate(150 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.4s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a",
  transform: "rotate(180 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.48s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a",
  transform: "rotate(210 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.56s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a",
  transform: "rotate(240 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.64s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a",
  transform: "rotate(270 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.72s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a",
  transform: "rotate(300 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.8s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xlinkHref: "#loader_svg__a",
  transform: "rotate(330 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0.88s",
  dur: "1s",
  repeatCount: "indefinite",
  values: "0;1;0"
}))));
export default SvgLoader;